import OpenRouterAlternativePage from '@/components/Pages/OpenRouterAlternativePage';

export default OpenRouterAlternativePage;
